import { ReactElement } from 'react';
import { Fail } from '@client/common/components/Fail';
import { ServerFail } from '@client/common/components/ServerFail';
import { BoxPlaceholder } from '@client/myAccount/common/components/BoxPlaceholder';
import { Props } from './';

export const BoxError = ({ title, remoteRecord, className }: Props): ReactElement => {
  const remoteRecordArray = Array.isArray(remoteRecord) ? remoteRecord : [remoteRecord];
  const hasServerError = remoteRecordArray.some((record) => record.hasServerError);
  const error = remoteRecordArray.find((record) => Boolean(record.error))?.error || null;

  return (
    <BoxPlaceholder title={title} className={className}>
      {hasServerError ? <ServerFail error={error} /> : <Fail error={error} />}
    </BoxPlaceholder>
  );
};
